class AnnouncementBarComponent extends HTMLElement {
  constructor() {
    super();
    this.slides = this.querySelectorAll('.announcement-bar__slide');
    this.currentIndex = 0;
    this.autoplayInterval = null;
    this.animationType = this.dataset.animation || 'fade';
    
    if (this.slides.length > 1) {
      this.init();
    }
  }

  init() {
    const prevBtn = this.querySelector('.slideshow-control--previous');
    const nextBtn = this.querySelector('.slideshow-control--next');

    if (prevBtn) {
      prevBtn.addEventListener('click', () => this.goToSlide('prev'));
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', () => this.goToSlide('next'));
    }

    const autoplaySpeed = this.getAttribute('autoplay');
    if (autoplaySpeed) {
      this.autoplaySpeed = parseInt(autoplaySpeed) * 1000;
      this.startAutoplay();
    }

    this.addEventListener('mouseenter', () => this.pauseAutoplay());
    this.addEventListener('mouseleave', () => {
      if (this.autoplaySpeed) {
        this.startAutoplay();
      }
    });

    // Initialize first slide
    this.initializeSlides();
  }

  initializeSlides() {
    this.slides.forEach((slide, index) => {
      if (index === 0) {
        slide.setAttribute('aria-hidden', 'false');
        slide.classList.add('slide-active');
      } else {
        slide.setAttribute('aria-hidden', 'true');
      }
    });
  }

  goToSlide(direction) {
    const prevIndex = this.currentIndex;
    
    if (direction === 'next') {
      this.currentIndex = (this.currentIndex + 1) % this.slides.length;
    } else {
      this.currentIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length;
    }

    this.animateSlides(direction, prevIndex);
  }

  animateSlides(direction, prevIndex) {
    const currentSlide = this.slides[prevIndex];
    const nextSlide = this.slides[this.currentIndex];

    // Remove all classes first
    this.slides.forEach(slide => {
      slide.classList.remove('slide-in-left', 'slide-in-right', 'slide-out-left', 'slide-out-right', 'slide-in-up', 'slide-active');
    });

    if (this.animationType === 'slide') {
      if (direction === 'next') {
        // Step 1: Current slide LEFT mein jaye
        currentSlide.classList.add('slide-out-left');
        currentSlide.setAttribute('aria-hidden', 'true');

        // Step 2: New slide RIGHT se aaye (thodi delay ke baad)
        setTimeout(() => {
          nextSlide.classList.add('slide-in-right');
          nextSlide.setAttribute('aria-hidden', 'false');
          
          // Animation complete hone ke baad active class add karo
          setTimeout(() => {
            nextSlide.classList.remove('slide-in-right');
            nextSlide.classList.add('slide-active');
          }, 500);
        }, 100);

      } else {
        // Prev button: Current slide RIGHT mein jaye
        currentSlide.classList.add('slide-out-right');
        currentSlide.setAttribute('aria-hidden', 'true');

        // New slide LEFT se aaye
        setTimeout(() => {
          nextSlide.classList.add('slide-in-left');
          nextSlide.setAttribute('aria-hidden', 'false');
          
          setTimeout(() => {
            nextSlide.classList.remove('slide-in-left');
            nextSlide.classList.add('slide-active');
          }, 500);
        }, 100);
      }

    } else if (this.animationType === 'slide-up') {
      currentSlide.setAttribute('aria-hidden', 'true');
      nextSlide.classList.add('slide-in-up');
      nextSlide.setAttribute('aria-hidden', 'false');
      
      setTimeout(() => {
        nextSlide.classList.remove('slide-in-up');
        nextSlide.classList.add('slide-active');
      }, 500);

    } else {
      // Fade animation
      currentSlide.setAttribute('aria-hidden', 'true');
      nextSlide.setAttribute('aria-hidden', 'false');
    }
  }

  startAutoplay() {
    this.pauseAutoplay();
    this.autoplayInterval = setInterval(() => {
      this.goToSlide('next');
    }, this.autoplaySpeed);
  }

  pauseAutoplay() {
    if (this.autoplayInterval) {
      clearInterval(this.autoplayInterval);
      this.autoplayInterval = null;
    }
  }
}

customElements.define('announcement-bar-component', AnnouncementBarComponent);